import type { TemplateKey } from '@core/email/templates';

/** Built-in templates grouped for compose UI and Settings (Pipeline + AI / candidate workflow). */
export const BUILTIN_EMAIL_TEMPLATE_GROUPS: { label: string; keys: TemplateKey[] }[] = [
  {
    label: 'Client — submissions & feedback',
    keys: ['first_submission', 'followup_day3', 'followup_day7', 'post_interview'],
  },
  {
    label: 'Client — interview coordination',
    keys: ['interview_confirmation', 'interview_panel_calendar_hold'],
  },
  {
    label: 'Candidate — interview & AI session',
    keys: [
      'interview_candidate_invite',
      'ai_interview_prep_invite_candidate',
      'ai_interview_reminder_candidate',
      'ai_interview_followup_candidate',
    ],
  },
  {
    label: 'Candidate — outcomes (after client decision)',
    keys: ['candidate_outcome_accept', 'candidate_outcome_reject', 'candidate_outcome_next_round'],
  },
];
